module.exports = __webpack_public_path__ + "img/5ac_03.860a4ed4.gif";